export default function isEqual(t, n) {
  return (
    !(!t || !n) &&
    t.date() === n.date() &&
    t.month() === n.month() &&
    t.year() === n.year()
  );
}
